import { Wrapper } from '@/components/atoms/Wrapper';
import LinvescoreAds from '@/components/organisms/AdCompanion/LivescoreAds/LinvescoreAds';
import { ReactNode, useEffect, useState } from 'react';
import TopCompetitionsCard from '../TopCompetitionsCard/TopCompetitionsCard';
import FavoriteCompetitorsCard from '../FavoriteCompetitorsCard/FavoriteCompetitorsCard';
import AllCompetitionsCard from '../AllCompetitionsCard/AllCompetitionsCard';
import { IAdsData } from '@/api/ads/interfaces';
import LivescoreSearch from '../LivescoreSearch/LivescoreSearch';
import LivescoreSidebarTabs from '@/components/atoms/LivescoreSidebarTabs/LivescoreSidebarTabs';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { cn } from '@/utils/cn';
import { useApp } from '@/context/AppContext';

const LivescoreLayout = ({ children, ads }: { children: ReactNode; ads: IAdsData }) => {
  const [opened, setOpened] = useState(false);
  const { ribbonClosed } = useApp();

  useEffect(() => {
    if (opened) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [opened]);

  return (
    <Wrapper className="grid md:grid-cols-[1fr_2fr] grid-cols-1 gap-4 px-4 md:mt-0 mt-20" fullWidth>
      <div
        className={cn(
          'h-screen md:h-auto overflow-y-scroll md:relative fixed md:w-auto w-full top-0 flex z-40 pr-1 md:pr-0 transition-all crollbar-none [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]',
          opened ? 'left-0' : '-left-[calc(100%-32px)] md:left-0',
        )}
      >
        <div
          className={cn(
            'sm:hidden block fixed inset-0 h-full w-[calc(100vw-32px)] dark:bg-black-500 bg-white -z-10 md:border-r-0 border-r dark:border-border-400 border-gray-250',
            opened ? 'left-0' : '-left-[calc(100%-32px)] md:left-0',
          )}
          aria-hidden
        />
        <div
          className={cn(
            'relative space-y-6 md:bg-transparent px-4 w-[calc(100vw-32px)] md:w-fit',
            ribbonClosed ? 'md:pt-0 pt-20' : 'md:pt-0 pt-36',
          )}
        >
          <LivescoreSearch />
          <LivescoreSidebarTabs />
          <TopCompetitionsCard />
          <FavoriteCompetitorsCard />
          <LinvescoreAds prefetchedAds={ads} />
          <AllCompetitionsCard />
          {/* ADDITIONAL PADDING */}
          <div className="h-4 w-1" />
        </div>
        <div className="relative">
          <button
            onClick={() => setOpened((prev) => !prev)}
            className="md:hidden fixed top-[20vh] rounded-r-md dark:bg-black-500 bg-white_theme-100 translate-x-[-1px] h-fit py-2 border-r border-t border-b dark:border-border-400 border-gray-250"
          >
            <ChevronRightIcon
              width={24}
              className={cn('transition-transform text-black dark:text-white', opened ? 'rotate-180' : '')}
            />
          </button>
        </div>
      </div>
      {children}
    </Wrapper>
  );
};

export default LivescoreLayout;
